import React, { useEffect, useState } from "react";
import { Spin, notification } from "antd";
import { Link, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import logoIcon from "@/assets/images/unzippd-logo.png";
import logoText from "@/assets/images/unzippd-wordmark-white-v7lIpH0R.png";
import { getEnvironmentConfig } from "../../config/environment";

const { baseURL } = getEnvironmentConfig();

const OrganizationTermsAndConditions = () => {
  const { formId: pathFormId } = useParams();
  const [searchParams] = useSearchParams();
  const formId = pathFormId || searchParams.get("formId");

  const [profileData, setProfileData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const org = profileData?.organization || profileData;
  const docUrl = profileData?.terms_condition || org?.terms_condition;
  const videoUrl =
    profileData?.terms_condition_video || org?.terms_condition_video;

  const getPdfEmbedUrl = (url) => {
    if (!url) return "";

    const joiner = url.includes("#") ? "&" : "#";
    return `${url}${joiner}toolbar=0&navpanes=0&scrollbar=0&view=FitH`;
  };
 
    useEffect(() => {
    let isMounted = true;

    const fetchLegalContent = async () => {
      if (!formId) {
        if (!isMounted) return;
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `${baseURL}/organization/legal-content/${formId}`,
        );

        if (!isMounted) return;

        setProfileData(response?.data?.data || response?.data || null);
      } catch (error) {
        if (!isMounted) return;
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchLegalContent();

    return () => {
      isMounted = false;
    };
  }, [formId]);

  return (
    <div className="min-h-screen bg-[#222222]">
      <header className="fixed top-0 z-40 w-full bg-black">
        <div className="mx-auto flex max-w-7xl items-center px-4 py-4">
          <Link
            to="/"
            aria-label="Unzippd home"
            className="flex items-center text-2xl font-extrabold text-white no-underline"
          >
            <img
              src={logoIcon}
              alt="Unzippd Word Mark"
              className="mr-4 inline-block w-8"
            />
            <img
              src={logoText}
              alt="Unzippd Word Mark"
              className="hidden w-[8rem] md:inline-block"
            />
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-3 pb-8 pt-24 sm:px-6 lg:px-8">
        <h1 className="mb-6 text-center text-2xl font-bold text-white sm:text-3xl">
          Welcome to Unzippd&apos;s Terms & Conditions
        </h1>
        {isLoading && <Spin tip="Loading content..." />}
        {videoUrl && !isLoading && (
          <video
            src={videoUrl}
            autoPlay
            loop
            muted
            playsInline
            className="mb-8 w-full max-h-[80vh] rounded-xl"
          />
        )}
        {docUrl && !isLoading && (
          <iframe
            src={getPdfEmbedUrl(docUrl)}
            title="Organisation Terms and Conditions PDF"
            className="w-full rounded-xl"
            height="800px"
            style={{
              border: "1px solid #ccc",
            }}
          />
        )}
      </main>
    </div>
  );
};

export default OrganizationTermsAndConditions;
